module.exports = __webpack_public_path__ + "static/media/SZ45003W_01.93be16d9.png";